import styled from "styled-components";

export const AboutPageWrapper = styled.div`
  background-color: #f5f5f5;
`;
